import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EditIcon from '@mui/icons-material/Edit';
import { Box, IconButton, Skeleton, Typography } from '@mui/material';
import { LABEL_EMAIL } from '../../../../shared/lib/constants';
import palette from '../../../../shared/lib/theme/palette';
import { EditEmail } from './EditEmail';
import { useAppContext } from '../../app/contexts/AppContext';
import { useState } from 'react';

export const EditUserEmail = () => {
  const { blackTwo, blackFive, blackOne } = palette;
  const { currentUser } = useAppContext();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { email } = currentUser ?? {};

  const emailEditOpen = () => {
    setIsOpen(true);
  };

  return (
    <Box borderBottom={`1px dashed ${blackFive}`} py="16px">
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h2" sx={{ textTransform: 'uppercase', color: blackTwo }}>
          {LABEL_EMAIL}
        </Typography>

        <IconButton color="primary" size="large" onClick={emailEditOpen}>
          {isEdit ? <ArrowBackIcon /> : <EditIcon />}
        </IconButton>
      </Box>

      <Typography variant="body2" sx={{ color: { blackOne }, fontWeight: '600', wordWrap: 'break-word' }}>
        {email ?? <Skeleton width={200} />}
      </Typography>

      <EditEmail setIsEdit={setIsEdit} isEdit={isEdit} setIsOpen={setIsOpen} isOpen={isOpen} />
    </Box>
  );
};
